import definitions from '../config/entitlementDefinitions.json';

export { definitions as defaultDefinitions };
export const featureName = (key, catalog = definitions, locale = 'sv') =>
    catalog.find(definition => definition.key === key)?.names?.[locale] || 'Ytterligare funktion';
export const featureDescription = (key, catalog = definitions, locale = 'sv') =>
    catalog.find(definition => definition.key === key)?.descriptions?.[locale] || '';
